import React from 'react';

export default function Img(props) {
  return <img alt="" {...props} crossOrigin="anonymous" />;
}
